import { Stack } from '@crossnokaye/ux-common';

interface SelectionsTemplateProps {
  searchInput: React.ReactNode;
  listActions: React.ReactNode;
  children: React.ReactNode;
}

export const SelectionsTemplate = ({
  searchInput,
  listActions,
  children,
}: SelectionsTemplateProps) => {
  return (
    <Stack className="h-full overflow-y-auto overflow-x-hidden" gap={'default'}>
      <Stack className="px-4 w-full">{searchInput}</Stack>
      <Stack className="px-4 w-full">{listActions}</Stack>
      <Stack className="flex-1 p-0">{children}</Stack>
    </Stack>
  );
};
